import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys as divisionKeys } from '../../divisions/queries';
import { RoundResultModifyResultRequest } from '~/apis/ssf';
import { keys as teamKeys } from '../../teams/queries';
import { keys as roundResultKeys } from '../queries';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useAddRoundResultMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: RoundResultModifyResultRequest }) =>
      SSF.api.roundResultsAddResultsCreate(id, payload),
    onSuccess: ({ data: response }) => {
      client.invalidateQueries({ queryKey: keys.lists() });
      client.invalidateQueries({ queryKey: roundResultKeys.lists() });
      client.invalidateQueries({ queryKey: teamKeys.detail(response.team.id) });
      client.invalidateQueries({ queryKey: divisionKeys.detail(response.team.division.id) });
    },
  });
}

export function useRemoveRoundResultMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: RoundResultModifyResultRequest }) =>
      SSF.api.roundResultsRemoveResultsCreate(id, payload),
    onSuccess: ({ data: response }) => {
      client.invalidateQueries({ queryKey: keys.lists() });
      client.invalidateQueries({ queryKey: roundResultKeys.lists() });
      client.invalidateQueries({ queryKey: teamKeys.detail(response.team.id) });
      client.invalidateQueries({ queryKey: divisionKeys.detail(response.team.division.id) });
    },
  });
}
